import React from 'react';

const steps = [
  {
    title: 'Reach out to Dial TPR',
    description: 'Call or WhatsApp our team with your shopping list, delivery location, and any brand preferences.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-6 w-6">
        <path d="M5 4h4l2 4-3 3c1.5 3 3.5 5 6 6l3-3 4 2v4c0 1-1 2-2 2C10.6 22 2 13.4 2 4c0-1 1-2 3-2h0z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'We coordinate with shops',
    description: 'Our agents speak with nearby partner stores, confirm availability, and secure the official shop invoice.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-6 w-6">
        <path d="M4 7h16M4 11h16M6 15h8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 21l4-4-4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Invoice & confirmation',
    description: 'We share the bill snapshot and estimated delivery time so you know exactly what will arrive.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-6 w-6">
        <path d="M7 3h10l2 4v12a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 9h6M9 13h4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Delivery with invoice',
    description: 'Our delivery executive picks up the items along with the shop invoice and hands it over at your doorstep.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-6 w-6">
        <path d="M3 7h13l5 5-5 5H3a2 2 0 01-2-2V9a2 2 0 012-2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13 7v10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const WorkSection = () => {
  return (
    <section className="bg-gradient-to-b from-white to-emerald-50 py-24">
      <div className="mx-auto max-w-6xl px-6 text-center">
        <span className="inline-flex items-center rounded-full bg-white px-3 py-1 text-xs font-semibold uppercase tracking-wide text-emerald-600 shadow-sm shadow-emerald-100">
          How It Works
        </span>
        <h2 className="mt-6 text-3xl font-bold text-slate-900 sm:text-4xl">From phone call to doorstep in four simple steps</h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-slate-600">
          Every Dial TPR order is managed by humans who know your neighbourhood. We take care of the follow-ups with shops and share every detail with you before the delivery executive sets out.
        </p>
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {steps.map((step) => (
            <div key={step.title} className="group relative overflow-hidden rounded-3xl border border-emerald-100 bg-white p-8 text-left shadow-sm shadow-emerald-100 transition hover:-translate-y-1 hover:shadow-lg hover:shadow-emerald-200/60">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-600">
                {step.icon}
              </div>
              <h3 className="mt-6 text-xl font-semibold text-slate-900">{step.title}</h3>
              <p className="mt-3 text-sm text-slate-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
